import React, { useState, useEffect } from 'react';
import { Identity } from '@wajeez-web/core/api-base';
import { CommonModalProps } from './Types';
import { Modal } from '@wajeez-web/components/ui';
import { InputSelect } from '@wajeez-web/components/ui';

export const BusinessGroupUserRoleOptions = [
  {
    label: 'User',
    value: 0,
  },
  {
    label: 'Moderator',
    value: 1,
  },
  {
    label: 'Admin',
    value: 2,
  },
];
const ChangeUserRoleModal: React.FC<
  CommonModalProps<Identity.BusinessGroupUserRole>
> = ({ onClose, onSubmit, isOpen, data }) => {
  const [userRole, setuserRole] = useState<Identity.BusinessGroupUserRole>(
    Identity.BusinessGroupUserRole.User
  );

  useEffect(() => {
    (data || data === 0) && setuserRole(data);
  }, [data]);

  return (
    <Modal
      title="Change User Role"
      open={isOpen}
      onClose={onClose}
      onSubmit={() => {
        onSubmit && onSubmit(userRole);
      }}
    >
      <InputSelect
        options={BusinessGroupUserRoleOptions}
        value={BusinessGroupUserRoleOptions.find(
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          (item) => item.value == Identity.BusinessGroupUserRole[userRole]
        )}
        required={true}
        label={'User Role'}
        name="userRole"
        onChange={(name, value: any) => setuserRole(value.value)}
      />
    </Modal>
  );
};

export default ChangeUserRoleModal;
